module.exports = __webpack_public_path__ + "media/images/homes/OpenOrders-ac3678815e3cafabc04148f5a0075b2c.png";